import { render, staticRenderFns } from "./DecorationHiddenPlayer.vue?vue&type=template&id=a2e15190&scoped=true&"
import script from "./DecorationHiddenPlayer.vue?vue&type=script&lang=js&"
export * from "./DecorationHiddenPlayer.vue?vue&type=script&lang=js&"
import style0 from "./DecorationHiddenPlayer.vue?vue&type=style&index=0&id=a2e15190&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e15190",
  null
  
)

export default component.exports